import { GenIcon } from '../helpers/IconBase.es.js';

const FillColorTextOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M3 19.5C3 18.6716 3.67157 18 4.5 18H19.5C20.3284 18 21 18.6716 21 19.5C21 20.3284 20.3284 21 19.5 21H4.5C3.67157 21 3 20.3284 3 19.5Z",
          fill: "#7D7D7D"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.9231 13.9396H10.0696L9.337 16H7L10.9707 6H13.0073L17 16H14.663L13.9231 13.9396ZM10.663 12.2706H13.3297L11.989 8.52747L10.663 12.2706Z",
          fill: "#7D7D7D"
        }
      }
    ]
  })(props);
};

export { FillColorTextOutlined };
